import specialOffers from './special-offers';

specialOffers();
